import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { loadImage } from 'bianco.images-loader';
import { Trans } from 'translations';
import Loader from 'components/loader';
import StarRating from 'react-star-rating-component';
import Icon from 'components/icon';
import Button from 'components/button';
import { connect } from 'react-redux';
import getPickerImage from 'util/misc/get-picker-image';
import reduxUtils from 'util/redux';
import { register, unregister } from 'util/dom/channeled-interactionobserver';
import { debounce } from 'lodash';
import { tooltipDuration } from 'constants/transitions-props';

/* eslint-disable camelcase */

class PickerTile extends PureComponent {
    static propTypes = {
        first_name: PropTypes.string.isRequired,
        rating_average: PropTypes.number.isRequired,
        rating_count: PropTypes.number,
        person_id: PropTypes.string,
        profile_picture: PropTypes.string,
        gender: PropTypes.string.isRequired,
        excluded: PropTypes.bool,
        isMobile: PropTypes.bool,
        setExcluded: PropTypes.func.isRequired,
        addTooltip: PropTypes.func,
        removeTooltip: PropTypes.func,
        facet: PropTypes.string,
    };

    state = {
        isLoading: false,
        isLoaded: false,
        isVisible: false,
        tooltipCreated: false,
    };

    componentDidMount() {
        if (!this.state.isLoaded) {
            register(this, 'picker-slider--tile', {
                threshold: 0.1,
            });
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if (!this.state.isVisible && nextState.isVisible === true) {
            if (!this.state.isLoaded && !this.state.isLoading) {
                this.lazyLoad(nextProps);
            }
        }

        if (this.state.isVisible && nextState.isVisible === false) {
            this.closeTooltip();
        }
    }

    componentWillUnmount() {
        this.wasUnmounted = true;
        unregister(this, 'picker-slider--tile', null);
    }

    onImageLoaded = () => {
        if (this.wasUnmounted) {
            return;
        }

        this.setState({
            isLoaded: true,
            isLoading: false,
        });
    };

    setExcluded = (excluded) => {
        const { person_id } = this.props;

        this.props.setExcluded({
            person_id,
            excluded,
        });

        this.showTooltip(excluded);
    };

    lazyLoad = () => { // eslint-disable-line
        this.setState({ isLoading: true });
        loadImage(this.userImage)
            .then(this.onImageLoaded);
    };

    get isHighlight() {
        return this.props.facet === 'highlight';
    }

    get userImage() {
        return getPickerImage(this.props);
    }

    getTooltipContent(isExcluded) {
        return (<Trans path={isExcluded ? 'checkout.pickers.excluded_tooltip' : 'checkout.pickers.included_tooltip'}/>);
    }

    tooltipHideTimeout = null;

    showTooltip = debounce((isExcluded) => {
        this.props.addTooltip('picker-slider', this.refs.root, {
            className: 'picker-tile--tooltip',
            facet: 'smaller-shadow',
            hasClose: false,
            mustShow: true,
            content: this.getTooltipContent(isExcluded),
            interactionType: 'none',
        });

        if (this.tooltipHideTimeout) {
            clearTimeout(this.tooltipHideTimeout);
        }

        this.tooltipHideTimeout = setTimeout(() => {
            this.props.removeTooltip('picker-slider', this.refs.root);
            this.tooltipHideTimeout = null;
        }, tooltipDuration);
    }, 200);


    renderRating() {
        const { first_name, rating_average, rating_count } = this.props;
        return (
            <div className="picker-tile--rating">
                <StarRating
                    name={first_name}
                    editing={false}
                    starColor="#ff6600"
                    emptyStarColor="#9f9fa1"
                    renderStarIcon={() => <div>&#9733;</div>}
                    starCount={5}
                    value={rating_average}
                />
                <span className="picker-tile--rating-average">
                    {rating_count}
                </span>
            </div>
        );
    }

    renderImage() {
        const { isLoading, isLoaded } = this.state;

        return (
            <div className="picker-tile--image">
                <div
                    className="picker-tile--image-inner"
                    style={{ backgroundImage: isLoaded ? `url('${ this.userImage }')` : null }}>
                    {isLoading && <Loader/>}
                </div>
            </div>
        );
    }

    renderTileContent() {
        const { first_name, excluded } = this.props;

        return (
            <div className="picker-tile--inner"
                onClick={() => this.setExcluded(!excluded)}>

                {this.renderImage()}

                <div className="picker-tile--name">
                    {first_name}
                </div>

                {this.renderRating()}

                {this.isHighlight ? null : (
                    <div className="picker-tile--actions">
                        <Button tabIndex="-1" className={'picker-tile--action picker-tile--exclude'}
                            size="small"
                            facet="bubble">
                            <Icon symbol={'basket-remove'} size={'large'}/>
                        </Button>
                        <Button tabIndex="-1" className={'picker-tile--action picker-tile--include'}
                            size="small"
                            facet="bubble">
                            <Icon symbol={'enable'} size={'large'}/>
                        </Button>
                    </div>
                )}
            </div>
        );
    }

    render() {
        const { excluded } = this.props;
        const { isVisible } = this.state;

        return (
            <article ref="root"
                className={classnames('picker-tile', { 'picker-tile__excluded': excluded })}>
                {isVisible && this.renderTileContent()}
            </article>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        isMobile: 'viewport.isMobile',
    }),
    reduxUtils.mapDispatchToProps({
        setExcluded: 'pickers.setExcluded',
        addTooltip: 'tooltip.add',
        removeTooltip: 'tooltip.remove',
    }),
)(PickerTile);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/picker-tile/index.js